import { Action } from '../actions'
import { ScreenSizeAction } from '../constants'
import { InitialState, ScreenSize } from '../state'

export const screenSize = (
  currentSize: ScreenSize = InitialState.screenSize(),
  action: Action
): ScreenSize => {
  switch (action.type) {
    case ScreenSizeAction.SET_PHONE_SIZE:
      return ScreenSize.Phone
    case ScreenSizeAction.SET_TABLET_PORTRAIT_SIZE:
      return ScreenSize.TabletPortrait
    case ScreenSizeAction.SET_TABLET_LANDSCAPE_SIZE:
      return ScreenSize.TabletLandscape
    case ScreenSizeAction.SET_DESKTOP_SIZE:
      return ScreenSize.Desktop
    case ScreenSizeAction.SET_DESKTOP_BIG_SIZE:
      return ScreenSize.DesktopBig
    default:
      return currentSize
  }
}
